import {
  Flex,
  Step,
  StepDescription,
  StepIndicator,
  Stepper,
  StepSeparator,
  StepStatus,
  StepTitle,
  useSteps,
} from '@chakra-ui/react';
import React from 'react';

import { COLOR_SCHEMES } from 'packages/common-frontend/theme';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { ComponentGridRenderer } from '~/core/routes/dev/ComponentGridRenderer';
import { PageTemplate } from '~/core/routes/dev/PageTemplate';
import { Icon } from '~/packages/common-frontend/components/icons';

// Constants
const COMPONENT_NAME = './chakra/Stepper';

const steps = [
  {
    id: 1,
    icon: 'info',
    title: 'Information',
    description: 'Step description',
  },
  {
    id: 2,
    icon: 'list',
    title: 'Details',
    description: 'Step description',
  },
  {
    id: 3,
    icon: 'money-check-dollar',
    title: 'Payment',
    description: 'Step description',
  },
  {
    id: 4,
    icon: 'check',
    title: 'Review',
    description: 'Step description',
  },
];

// Fragments
const StepperExample = ({
  ...StepperProps
}: Omit<React.ComponentProps<typeof Stepper>, 'index' | 'children'>) => {
  const { activeStep, setActiveStep } = useSteps({
    index: 1,
    count: steps.length,
  });

  return (
    <Stepper {...StepperProps} index={activeStep}>
      {steps.map((step, index) => (
        <Step key={step.id}>
          <Flex
            direction="column"
            gap="0.625rem"
            alignItems="center"
            onClick={() => setActiveStep(index)}
          >
            <StepIndicator>
              <StepStatus
                complete={<Icon icon={step.icon} />}
                incomplete={<Icon icon={step.icon} />}
                active={<Icon icon={step.icon} />}
              />
            </StepIndicator>
            <Flex direction="column" alignItems="center">
              <StepTitle>{step.title}</StepTitle>
              <StepDescription>{step.description}</StepDescription>
            </Flex>
          </Flex>

          <StepSeparator />
        </Step>
      ))}
    </Stepper>
  );
};

const RouteBase = () => (
  <PageTemplate title={COMPONENT_NAME}>
    <ComponentGridRenderer
      primaries={COLOR_SCHEMES}
      primaryPropName="colorScheme"
      secondaries={[null]}
      tertiaries={[null]}
      width="100%"
    >
      {({ primary: colorScheme }) => (
        <StepperExample colorScheme={colorScheme} />
      )}
    </ComponentGridRenderer>
  </PageTemplate>
);

// Exports
export const Route = () => (
  <RouteErrorBoundary
    resetAfterCatch={false}
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <div>Uh oh</div>;
    }}
  >
    <RouteBase />
  </RouteErrorBoundary>
);
